import classnames from 'classnames'
import FieldErrorText from 'components/field_error_text'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import 'styles/components/form-group.scss'

const FormGroup = ({ children, className: aClassName, errorClassName, name, error }) => {
  const className = classnames(aClassName, 'form-group', {
    'has-error': error && find(error.fieldErrors, { field: name })
  })

  return (
    <div className={className}>
      {children}
      <FieldErrorText error={error} name={name} className={errorClassName} />
    </div>
  )
}

FormGroup.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  errorClassName: PropTypes.string,
  error: PropTypes.instanceOf(Error),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

FormGroup.defaultProps = {
  className: null,
  errorClassName: null,
  error: null,
  children: null
}

export default FormGroup
